// ⚠️ FILE SINH TỰ ĐỘNG — ĐỪNG SỬA TAY.
//
// Nguồn: cnv-server-shared/src/constants/phoneCountries.js + src/utils/phoneIntl.js
// (kernel dùng chung Core + Work SaaS + Connect SaaS). Sinh lại sau khi sửa kernel:
//     node tools/check-phone-policy-drift.js --write
// Gate check-all.sh sẽ đỏ nếu file này lệch với kernel.
//
// Vì sao phải sinh: cnv-ui chạy trong trình duyệt (ESM) nên không require được gói BE
// @cnv/server-shared. Chép tay thì FE nhận số mà BE trả 400 — đúng thứ file này tránh.

export const PHONE_E164_MAX_DIGITS = 15;
const PHONE_NSN_MIN = 4;
const PHONE_NSN_MAX = 14;

export const PHONE_COUNTRIES = [
  { iso2: 'US', dial: '1', name: 'United States', len: [10, 10] },
  { iso2: 'CA', dial: '1', name: 'Canada', len: [10, 10], areas: ['204', '226', '236', '249', '250', '263', '289', '306', '343', '354', '365', '367', '368', '382', '387', '403', '416', '418', '428', '431', '437', '438', '450', '468', '474', '506', '514', '519', '548', '579', '581', '584', '587', '600', '604', '613', '639', '647', '672', '683', '705', '709', '742', '753', '778', '780', '782', '807', '819', '825', '867', '873', '879', '902', '905'] },
  { iso2: 'AG', dial: '1', name: 'Antigua and Barbuda', len: [10, 10], areas: ['268'] },
  { iso2: 'AI', dial: '1', name: 'Anguilla', len: [10, 10], areas: ['264'] },
  { iso2: 'AS', dial: '1', name: 'American Samoa', len: [10, 10], areas: ['684'] },
  { iso2: 'BB', dial: '1', name: 'Barbados', len: [10, 10], areas: ['246'] },
  { iso2: 'BM', dial: '1', name: 'Bermuda', len: [10, 10], areas: ['441'] },
  { iso2: 'BS', dial: '1', name: 'Bahamas', len: [10, 10], areas: ['242'] },
  { iso2: 'DM', dial: '1', name: 'Dominica', len: [10, 10], areas: ['767'] },
  { iso2: 'DO', dial: '1', name: 'Dominican Republic', len: [10, 10], areas: ['809', '829', '849'] },
  { iso2: 'GD', dial: '1', name: 'Grenada', len: [10, 10], areas: ['473'] },
  { iso2: 'GU', dial: '1', name: 'Guam', len: [10, 10], areas: ['671'] },
  { iso2: 'JM', dial: '1', name: 'Jamaica', len: [10, 10], areas: ['876', '658'] },
  { iso2: 'KN', dial: '1', name: 'Saint Kitts and Nevis', len: [10, 10], areas: ['869'] },
  { iso2: 'KY', dial: '1', name: 'Cayman Islands', len: [10, 10], areas: ['345'] },
  { iso2: 'LC', dial: '1', name: 'Saint Lucia', len: [10, 10], areas: ['758'] },
  { iso2: 'MP', dial: '1', name: 'Northern Mariana Islands', len: [10, 10], areas: ['670'] },
  { iso2: 'MS', dial: '1', name: 'Montserrat', len: [10, 10], areas: ['664'] },
  { iso2: 'PR', dial: '1', name: 'Puerto Rico', len: [10, 10], areas: ['787', '939'] },
  { iso2: 'SX', dial: '1', name: 'Sint Maarten', len: [10, 10], areas: ['721'] },
  { iso2: 'TC', dial: '1', name: 'Turks and Caicos Islands', len: [10, 10], areas: ['649'] },
  { iso2: 'TT', dial: '1', name: 'Trinidad and Tobago', len: [10, 10], areas: ['868'] },
  { iso2: 'VC', dial: '1', name: 'Saint Vincent and the Grenadines', len: [10, 10], areas: ['784'] },
  { iso2: 'VG', dial: '1', name: 'British Virgin Islands', len: [10, 10], areas: ['284'] },
  { iso2: 'VI', dial: '1', name: 'U.S. Virgin Islands', len: [10, 10], areas: ['340'] },
  { iso2: 'EG', dial: '20', name: 'Egypt' },
  { iso2: 'SS', dial: '211', name: 'South Sudan' },
  { iso2: 'MA', dial: '212', name: 'Morocco' },
  { iso2: 'EH', dial: '212', name: 'Western Sahara', areas: ['528'] },
  { iso2: 'DZ', dial: '213', name: 'Algeria' },
  { iso2: 'TN', dial: '216', name: 'Tunisia' },
  { iso2: 'LY', dial: '218', name: 'Libya' },
  { iso2: 'GM', dial: '220', name: 'Gambia' },
  { iso2: 'SN', dial: '221', name: 'Senegal' },
  { iso2: 'MR', dial: '222', name: 'Mauritania' },
  { iso2: 'ML', dial: '223', name: 'Mali' },
  { iso2: 'GN', dial: '224', name: 'Guinea' },
  { iso2: 'CI', dial: '225', name: 'Côte d\'Ivoire' },
  { iso2: 'BF', dial: '226', name: 'Burkina Faso' },
  { iso2: 'NE', dial: '227', name: 'Niger' },
  { iso2: 'TG', dial: '228', name: 'Togo' },
  { iso2: 'BJ', dial: '229', name: 'Benin' },
  { iso2: 'MU', dial: '230', name: 'Mauritius' },
  { iso2: 'LR', dial: '231', name: 'Liberia' },
  { iso2: 'SL', dial: '232', name: 'Sierra Leone' },
  { iso2: 'GH', dial: '233', name: 'Ghana' },
  { iso2: 'NG', dial: '234', name: 'Nigeria' },
  { iso2: 'TD', dial: '235', name: 'Chad' },
  { iso2: 'CF', dial: '236', name: 'Central African Republic' },
  { iso2: 'CM', dial: '237', name: 'Cameroon' },
  { iso2: 'CV', dial: '238', name: 'Cape Verde' },
  { iso2: 'ST', dial: '239', name: 'São Tomé and Príncipe' },
  { iso2: 'GQ', dial: '240', name: 'Equatorial Guinea' },
  { iso2: 'GA', dial: '241', name: 'Gabon' },
  { iso2: 'CG', dial: '242', name: 'Republic of the Congo' },
  { iso2: 'CD', dial: '243', name: 'DR Congo' },
  { iso2: 'AO', dial: '244', name: 'Angola' },
  { iso2: 'GW', dial: '245', name: 'Guinea-Bissau' },
  { iso2: 'IO', dial: '246', name: 'British Indian Ocean Territory' },
  { iso2: 'SC', dial: '248', name: 'Seychelles' },
  { iso2: 'SD', dial: '249', name: 'Sudan' },
  { iso2: 'RW', dial: '250', name: 'Rwanda' },
  { iso2: 'ET', dial: '251', name: 'Ethiopia' },
  { iso2: 'SO', dial: '252', name: 'Somalia' },
  { iso2: 'DJ', dial: '253', name: 'Djibouti' },
  { iso2: 'KE', dial: '254', name: 'Kenya' },
  { iso2: 'TZ', dial: '255', name: 'Tanzania' },
  { iso2: 'UG', dial: '256', name: 'Uganda' },
  { iso2: 'BI', dial: '257', name: 'Burundi' },
  { iso2: 'MZ', dial: '258', name: 'Mozambique' },
  { iso2: 'ZM', dial: '260', name: 'Zambia' },
  { iso2: 'MG', dial: '261', name: 'Madagascar' },
  { iso2: 'RE', dial: '262', name: 'Réunion' },
  { iso2: 'YT', dial: '262', name: 'Mayotte', areas: ['269', '639'] },
  { iso2: 'ZW', dial: '263', name: 'Zimbabwe' },
  { iso2: 'NA', dial: '264', name: 'Namibia' },
  { iso2: 'MW', dial: '265', name: 'Malawi' },
  { iso2: 'LS', dial: '266', name: 'Lesotho' },
  { iso2: 'BW', dial: '267', name: 'Botswana' },
  { iso2: 'SZ', dial: '268', name: 'Eswatini' },
  { iso2: 'KM', dial: '269', name: 'Comoros' },
  { iso2: 'ZA', dial: '27', name: 'South Africa' },
  { iso2: 'SH', dial: '290', name: 'Saint Helena' },
  { iso2: 'ER', dial: '291', name: 'Eritrea' },
  { iso2: 'AW', dial: '297', name: 'Aruba' },
  { iso2: 'FO', dial: '298', name: 'Faroe Islands' },
  { iso2: 'GL', dial: '299', name: 'Greenland' },
  { iso2: 'GR', dial: '30', name: 'Greece' },
  { iso2: 'NL', dial: '31', name: 'Netherlands' },
  { iso2: 'BE', dial: '32', name: 'Belgium' },
  { iso2: 'FR', dial: '33', name: 'France', len: [9, 9] },
  { iso2: 'ES', dial: '34', name: 'Spain', len: [9, 9] },
  { iso2: 'GI', dial: '350', name: 'Gibraltar' },
  { iso2: 'PT', dial: '351', name: 'Portugal', len: [9, 9] },
  { iso2: 'LU', dial: '352', name: 'Luxembourg' },
  { iso2: 'IE', dial: '353', name: 'Ireland' },
  { iso2: 'IS', dial: '354', name: 'Iceland' },
  { iso2: 'AL', dial: '355', name: 'Albania' },
  { iso2: 'MT', dial: '356', name: 'Malta' },
  { iso2: 'CY', dial: '357', name: 'Cyprus' },
  { iso2: 'FI', dial: '358', name: 'Finland' },
  { iso2: 'AX', dial: '358', name: 'Åland Islands', areas: ['18'] },
  { iso2: 'BG', dial: '359', name: 'Bulgaria' },
  { iso2: 'HU', dial: '36', name: 'Hungary' },
  { iso2: 'LT', dial: '370', name: 'Lithuania' },
  { iso2: 'LV', dial: '371', name: 'Latvia' },
  { iso2: 'EE', dial: '372', name: 'Estonia' },
  { iso2: 'MD', dial: '373', name: 'Moldova' },
  { iso2: 'AM', dial: '374', name: 'Armenia' },
  { iso2: 'BY', dial: '375', name: 'Belarus' },
  { iso2: 'AD', dial: '376', name: 'Andorra' },
  { iso2: 'MC', dial: '377', name: 'Monaco' },
  { iso2: 'SM', dial: '378', name: 'San Marino' },
  { iso2: 'VA', dial: '379', name: 'Vatican City' },
  { iso2: 'UA', dial: '380', name: 'Ukraine' },
  { iso2: 'RS', dial: '381', name: 'Serbia' },
  { iso2: 'ME', dial: '382', name: 'Montenegro' },
  { iso2: 'XK', dial: '383', name: 'Kosovo' },
  { iso2: 'HR', dial: '385', name: 'Croatia' },
  { iso2: 'SI', dial: '386', name: 'Slovenia' },
  { iso2: 'BA', dial: '387', name: 'Bosnia and Herzegovina' },
  { iso2: 'MK', dial: '389', name: 'North Macedonia' },
  { iso2: 'IT', dial: '39', name: 'Italy' },
  { iso2: 'RO', dial: '40', name: 'Romania' },
  { iso2: 'CH', dial: '41', name: 'Switzerland' },
  { iso2: 'CZ', dial: '420', name: 'Czechia' },
  { iso2: 'SK', dial: '421', name: 'Slovakia' },
  { iso2: 'LI', dial: '423', name: 'Liechtenstein' },
  { iso2: 'AT', dial: '43', name: 'Austria' },
  { iso2: 'GB', dial: '44', name: 'United Kingdom', len: [9, 10] },
  { iso2: 'GG', dial: '44', name: 'Guernsey', len: [10, 10], areas: ['1481', '7781', '7839', '7911'] },
  { iso2: 'JE', dial: '44', name: 'Jersey', len: [10, 10], areas: ['1534', '7509', '7700', '7797', '7829', '7937'] },
  { iso2: 'IM', dial: '44', name: 'Isle of Man', len: [10, 10], areas: ['1624', '7624', '7524', '7924'] },
  { iso2: 'DK', dial: '45', name: 'Denmark' },
  { iso2: 'SE', dial: '46', name: 'Sweden' },
  { iso2: 'NO', dial: '47', name: 'Norway' },
  { iso2: 'SJ', dial: '47', name: 'Svalbard and Jan Mayen', areas: ['79'] },
  { iso2: 'PL', dial: '48', name: 'Poland' },
  { iso2: 'DE', dial: '49', name: 'Germany' },
  { iso2: 'FK', dial: '500', name: 'Falkland Islands' },
  { iso2: 'BZ', dial: '501', name: 'Belize' },
  { iso2: 'GT', dial: '502', name: 'Guatemala' },
  { iso2: 'SV', dial: '503', name: 'El Salvador' },
  { iso2: 'HN', dial: '504', name: 'Honduras' },
  { iso2: 'NI', dial: '505', name: 'Nicaragua' },
  { iso2: 'CR', dial: '506', name: 'Costa Rica' },
  { iso2: 'PA', dial: '507', name: 'Panama' },
  { iso2: 'PM', dial: '508', name: 'Saint Pierre and Miquelon' },
  { iso2: 'HT', dial: '509', name: 'Haiti' },
  { iso2: 'PE', dial: '51', name: 'Peru' },
  { iso2: 'MX', dial: '52', name: 'Mexico', len: [10, 10] },
  { iso2: 'CU', dial: '53', name: 'Cuba' },
  { iso2: 'AR', dial: '54', name: 'Argentina' },
  { iso2: 'BR', dial: '55', name: 'Brazil', len: [10, 11] },
  { iso2: 'CL', dial: '56', name: 'Chile' },
  { iso2: 'CO', dial: '57', name: 'Colombia' },
  { iso2: 'VE', dial: '58', name: 'Venezuela' },
  { iso2: 'BO', dial: '591', name: 'Bolivia' },
  { iso2: 'GY', dial: '592', name: 'Guyana' },
  { iso2: 'EC', dial: '593', name: 'Ecuador' },
  { iso2: 'GF', dial: '594', name: 'French Guiana' },
  { iso2: 'PY', dial: '595', name: 'Paraguay' },
  { iso2: 'MQ', dial: '596', name: 'Martinique' },
  { iso2: 'SR', dial: '597', name: 'Suriname' },
  { iso2: 'UY', dial: '598', name: 'Uruguay' },
  { iso2: 'CW', dial: '599', name: 'Curaçao' },
  { iso2: 'BQ', dial: '599', name: 'Caribbean Netherlands', areas: ['3', '4', '7'] },
  { iso2: 'GP', dial: '590', name: 'Guadeloupe' },
  { iso2: 'BL', dial: '590', name: 'Saint Barthélemy', areas: ['590277', '690'] },
  { iso2: 'MF', dial: '590', name: 'Saint Martin', areas: ['590870', '690'] },
  { iso2: 'MY', dial: '60', name: 'Malaysia', len: [9, 10] },
  { iso2: 'AU', dial: '61', name: 'Australia', len: [9, 9] },
  { iso2: 'CC', dial: '61', name: 'Cocos (Keeling) Islands', areas: ['891'] },
  { iso2: 'CX', dial: '61', name: 'Christmas Island', areas: ['891'] },
  { iso2: 'ID', dial: '62', name: 'Indonesia', len: [8, 12] },
  { iso2: 'PH', dial: '63', name: 'Philippines', len: [9, 10] },
  { iso2: 'NZ', dial: '64', name: 'New Zealand', len: [8, 10] },
  { iso2: 'SG', dial: '65', name: 'Singapore', len: [8, 8] },
  { iso2: 'TH', dial: '66', name: 'Thailand', len: [8, 9] },
  { iso2: 'TL', dial: '670', name: 'Timor-Leste' },
  { iso2: 'NF', dial: '672', name: 'Norfolk Island' },
  { iso2: 'BN', dial: '673', name: 'Brunei' },
  { iso2: 'NR', dial: '674', name: 'Nauru' },
  { iso2: 'PG', dial: '675', name: 'Papua New Guinea' },
  { iso2: 'TO', dial: '676', name: 'Tonga' },
  { iso2: 'SB', dial: '677', name: 'Solomon Islands' },
  { iso2: 'VU', dial: '678', name: 'Vanuatu' },
  { iso2: 'FJ', dial: '679', name: 'Fiji' },
  { iso2: 'PW', dial: '680', name: 'Palau' },
  { iso2: 'WF', dial: '681', name: 'Wallis and Futuna' },
  { iso2: 'CK', dial: '682', name: 'Cook Islands' },
  { iso2: 'NU', dial: '683', name: 'Niue' },
  { iso2: 'WS', dial: '685', name: 'Samoa' },
  { iso2: 'KI', dial: '686', name: 'Kiribati' },
  { iso2: 'NC', dial: '687', name: 'New Caledonia' },
  { iso2: 'TV', dial: '688', name: 'Tuvalu' },
  { iso2: 'PF', dial: '689', name: 'French Polynesia' },
  { iso2: 'TK', dial: '690', name: 'Tokelau' },
  { iso2: 'FM', dial: '691', name: 'Micronesia' },
  { iso2: 'MH', dial: '692', name: 'Marshall Islands' },
  { iso2: 'RU', dial: '7', name: 'Russia', len: [10, 10] },
  { iso2: 'KZ', dial: '7', name: 'Kazakhstan', len: [10, 10], areas: ['6', '7'] },
  { iso2: 'JP', dial: '81', name: 'Japan', len: [9, 10] },
  { iso2: 'KR', dial: '82', name: 'South Korea', len: [8, 10] },
  { iso2: 'VN', dial: '84', name: 'Vietnam', len: [9, 10] },
  { iso2: 'HK', dial: '852', name: 'Hong Kong', len: [8, 8] },
  { iso2: 'MO', dial: '853', name: 'Macao', len: [8, 8] },
  { iso2: 'KH', dial: '855', name: 'Cambodia' },
  { iso2: 'LA', dial: '856', name: 'Laos' },
  { iso2: 'CN', dial: '86', name: 'China', len: [7, 11] },
  { iso2: 'BD', dial: '880', name: 'Bangladesh' },
  { iso2: 'TW', dial: '886', name: 'Taiwan', len: [8, 9] },
  { iso2: 'TR', dial: '90', name: 'Türkiye', len: [10, 10] },
  { iso2: 'IN', dial: '91', name: 'India', len: [10, 10] },
  { iso2: 'PK', dial: '92', name: 'Pakistan' },
  { iso2: 'AF', dial: '93', name: 'Afghanistan' },
  { iso2: 'LK', dial: '94', name: 'Sri Lanka' },
  { iso2: 'MM', dial: '95', name: 'Myanmar' },
  { iso2: 'MV', dial: '960', name: 'Maldives' },
  { iso2: 'LB', dial: '961', name: 'Lebanon' },
  { iso2: 'JO', dial: '962', name: 'Jordan' },
  { iso2: 'SY', dial: '963', name: 'Syria' },
  { iso2: 'IQ', dial: '964', name: 'Iraq' },
  { iso2: 'KW', dial: '965', name: 'Kuwait' },
  { iso2: 'SA', dial: '966', name: 'Saudi Arabia' },
  { iso2: 'YE', dial: '967', name: 'Yemen' },
  { iso2: 'OM', dial: '968', name: 'Oman' },
  { iso2: 'PS', dial: '970', name: 'Palestine' },
  { iso2: 'AE', dial: '971', name: 'United Arab Emirates' },
  { iso2: 'IL', dial: '972', name: 'Israel' },
  { iso2: 'BH', dial: '973', name: 'Bahrain' },
  { iso2: 'QA', dial: '974', name: 'Qatar' },
  { iso2: 'BT', dial: '975', name: 'Bhutan' },
  { iso2: 'MN', dial: '976', name: 'Mongolia' },
  { iso2: 'NP', dial: '977', name: 'Nepal' },
  { iso2: 'IR', dial: '98', name: 'Iran' },
  { iso2: 'TJ', dial: '992', name: 'Tajikistan' },
  { iso2: 'TM', dial: '993', name: 'Turkmenistan' },
  { iso2: 'AZ', dial: '994', name: 'Azerbaijan' },
  { iso2: 'GE', dial: '995', name: 'Georgia' },
  { iso2: 'KG', dial: '996', name: 'Kyrgyzstan' },
  { iso2: 'UZ', dial: '998', name: 'Uzbekistan' },
];

/**
 * SỐ ĐIỆN THOẠI QUỐC TẾ — logic dùng chung Core / Work SaaS / Connect SaaS.
 *
 * File này là NGUỒN DUY NHẤT: bản FE `cnv-ui/src/utils/phonePolicy.js` được SINH RA
 * từ chính file này (kèm dữ liệu phonecountries) bằng
 *     node tools/check-phone-policy-drift.js --write
 * nên KHÔNG được `require` gì ngoài `../constants/phoneCountries`, và mọi hàm phải
 * thuần (không I/O, không phụ thuộc Node).
 *
 * QUY ƯỚC LƯU (đọc kỹ trước khi đổi):
 *   • Việt Nam  → lưu dạng nội địa `0xxxxxxxxx`. Đây là dạng đang nằm trong DB của cả
 *     3 hệ; đổi sang E.164 là phải migrate + chỉnh mọi chỗ so khớp (login OTP, ghép
 *     hội thoại chat, tìm kiếm khách hàng). Không đáng.
 *   • Nước khác → lưu E.164 `+<mã quốc gia><số nội địa>`, ví dụ `+12265035441`.
 *   `phoneVariants()` bên `./phone.js` vẫn sinh đủ 3 biến thể VN nên tra cứu không đổi.
 */


/** Nước mặc định khi không đoán được gì từ giá trị (thị trường gốc của CNV). */
const PHONE_DEFAULT_ISO2 = 'VN';

/**
 * Cờ quốc gia từ mã ISO2 — ghép 2 ký tự Regional Indicator (U+1F1E6 + offset).
 * Không nhúng ảnh, không tải font: hệ điều hành tự vẽ.
 * `flagEmoji('CA')` → '🇨🇦'. ISO2 sai → '🏳️'.
 */
function flagEmoji(iso2) {
  const code = String(iso2 || '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return '🏳️';
  return String.fromCodePoint(
    0x1f1e6 + (code.charCodeAt(0) - 65),
    0x1f1e6 + (code.charCodeAt(1) - 65),
  );
}

/** Chỉ giữ chữ số. `'+1 (226) 503-5441'` → `'12265035441'`. */
function phoneDigits(value) {
  return String(value == null ? '' : value).replace(/\D/g, '');
}

/** Tra 1 nước theo ISO2. Không có → null. */
function findPhoneCountry(iso2) {
  const code = String(iso2 || '').trim().toUpperCase();
  return PHONE_COUNTRIES.find((c) => c.iso2 === code) || null;
}

/** Dải độ dài phần nội địa của 1 nước — nước chưa khai `len` thì dùng dải chung. */
function nsnRange(country) {
  if (country && Array.isArray(country.len)) return country.len;
  return [PHONE_NSN_MIN, PHONE_NSN_MAX];
}

/**
 * Đoán nước từ chuỗi chữ số ĐÃ BỎ dấu `+` (vd '12265035441').
 * Ưu tiên: mã quốc gia dài nhất; cùng mã quốc gia thì nước có `areas` khớp thắng
 * (nhờ vậy `+1 226…` ra Canada chứ không phải Mỹ), không nước nào khớp `areas`
 * thì rơi về nước "chủ" (nước đầu tiên cùng mã, không khai `areas`).
 */
function countryFromE164Digits(digits) {
  const d = phoneDigits(digits);
  if (!d) return null;

  let best = null;
  for (const c of PHONE_COUNTRIES) {
    if (!d.startsWith(c.dial)) continue;
    const rest = d.slice(c.dial.length);
    const hitArea = Array.isArray(c.areas) && c.areas.some((a) => rest.startsWith(a));
    const score = c.dial.length * 10 + (hitArea ? 2 : 0) + (c.areas ? 0 : 1);
    if (!best || score > best.score) best = { country: c, score };
  }
  return best ? best.country : null;
}

/**
 * Tách 1 giá trị bất kỳ thành {nước, mã quốc gia, số nội địa}.
 *
 *   parsePhone('+1 226 503 5441')   → { iso2: 'CA', dial: '1',  national: '2265035441' }
 *   parsePhone('0901234567')        → { iso2: 'VN', dial: '84', national: '901234567' }
 *   parsePhone('501234567', 'CA')   → { iso2: 'CA', dial: '1',  national: '501234567' }
 *
 * @param {string} value
 * @param {string} [defaultIso2] nước giả định khi giá trị KHÔNG có mã quốc tế
 * @returns {{iso2:string, dial:string, national:string, e164:string, empty:boolean, valid:boolean}}
 */
function parsePhone(value, defaultIso2) {
  const raw = String(value == null ? '' : value).trim();
  const fallbackIso2 = (findPhoneCountry(defaultIso2) ? defaultIso2 : PHONE_DEFAULT_ISO2).toUpperCase();
  const fallback = findPhoneCountry(fallbackIso2);

  if (!raw) {
    return {
      iso2: fallbackIso2, dial: fallback ? fallback.dial : '', national: '', e164: '', empty: true, valid: true,
    };
  }

  const intl = raw.startsWith('+') || raw.startsWith('00');
  let digits = phoneDigits(raw);
  if (raw.startsWith('00')) digits = digits.replace(/^00/, '');

  let country = null;
  let national = '';

  if (intl) {
    country = countryFromE164Digits(digits);
    national = country ? digits.slice(country.dial.length) : digits;
  } else if (digits.startsWith('0')) {
    // Số nội địa có số 0 trunk (VN, Anh, Đức…) — nước lấy theo mặc định.
    country = fallback;
    national = digits.replace(/^0+/, '');
  } else {
    // Chuỗi trần: nếu nó mở đầu bằng đúng mã quốc gia của nước mặc định và dôi ra đủ
    // dài thì hiểu là thiếu dấu `+` (Excel hay nuốt), còn lại coi là số nội địa.
    const guess = countryFromE164Digits(digits);
    const looksIntl = guess
      && digits.length > guess.dial.length
      && digits.slice(guess.dial.length).length >= nsnRange(guess)[0]
      && digits.length > nsnRange(fallback)[1];
    if (looksIntl) {
      country = guess;
      national = digits.slice(guess.dial.length);
    } else {
      country = fallback;
      national = digits;
    }
  }

  const dial = country ? country.dial : '';
  const e164 = national ? `+${dial}${national}` : '';
  return {
    iso2: country ? country.iso2 : fallbackIso2,
    dial,
    national,
    e164,
    empty: false,
    valid: isValidNational(country, national),
  };
}

/**
 * Số nội địa có hợp lệ với nước đó không: đúng dải độ dài của nước, và tổng
 * (mã quốc gia + nội địa) không vượt trần 15 chữ số của E.164.
 */
function isValidNational(country, national) {
  const n = phoneDigits(national);
  if (!country || !n) return false;
  const [min, max] = nsnRange(country);
  if (n.length < min || n.length > max) return false;
  return country.dial.length + n.length <= PHONE_E164_MAX_DIGITS;
}

/**
 * Validate SĐT cho form nhân viên / khách hàng.
 * Trống ('' / null / undefined) → HỢP LỆ (nhân viên có thể chưa có SĐT).
 *
 * @param {string} value
 * @param {string} [defaultIso2]
 * @returns {boolean}
 */
function isValidPhoneIntl(value, defaultIso2) {
  if (value == null || String(value).trim() === '') return true;
  if (typeof value !== 'string' && typeof value !== 'number') return false;
  return parsePhone(value, defaultIso2).valid;
}

/**
 * Ghép {nước, số nội địa} thành chuỗi lưu/gửi đi theo QUY ƯỚC LƯU ở đầu file.
 * Dùng CHUNG cho BE (formatPhoneForStorage) và cho ô nhập FE lúc người dùng đang gõ dở —
 * để hai bên không tự đặt luật riêng rồi trôi.
 */
function composePhone(iso2, national) {
  const country = findPhoneCountry(iso2);
  const digits = phoneDigits(national);
  if (!digits) return '';
  if (!country) return digits;
  if (country.iso2 === 'VN') return `0${digits}`;
  return `+${country.dial}${digits}`;
}

/**
 * Chuẩn hoá trước khi ghi DB — xem "QUY ƯỚC LƯU" ở đầu file.
 * Không parse được thì TRẢ NGUYÊN chuỗi đã trim (thà giữ dữ liệu người dùng gõ
 * còn hơn ghi rỗng); validate là việc của `isValidPhoneIntl`.
 */
function formatPhoneForStorage(value, defaultIso2) {
  const raw = String(value == null ? '' : value).trim();
  if (!raw) return '';
  const p = parsePhone(raw, defaultIso2);
  if (!p.valid) return raw;
  return composePhone(p.iso2, p.national);
}

/**
 * Dạng hiển thị gọn: VN giữ `0xxxxxxxxx`, còn lại `+<mã> <số nội địa>`.
 * Không cắt nhóm theo từng nước (việc đó cần metadata của libphonenumber).
 */
function formatPhoneDisplay(value, defaultIso2) {
  const raw = String(value == null ? '' : value).trim();
  if (!raw) return '';
  const p = parsePhone(raw, defaultIso2);
  if (!p.valid) return raw;
  if (p.iso2 === 'VN') return `0${p.national}`;
  return `+${p.dial} ${p.national}`;
}

/**
 * Ô tìm kiếm của bộ chọn mã vùng: gõ tên nước, mã ISO2, mã quốc gia ("+1", "84")
 * hay MÃ VÙNG nội địa ("226" → Canada) đều ra.
 *
 * @param {object} country 1 dòng của PHONE_COUNTRIES
 * @param {string} query chuỗi người dùng gõ
 * @param {string} [localizedName] tên nước theo ngôn ngữ đang dùng (Intl.DisplayNames)
 */
function phoneCountryMatches(country, query, localizedName) {
  const q = String(query || '').trim().toLowerCase().replace(/^\+/, '');
  if (!q) return true;
  if (!country) return false;

  const names = [country.name, localizedName].filter(Boolean).map((s) => String(s).toLowerCase());
  if (names.some((n) => n.includes(q))) return true;
  if (country.iso2.toLowerCase() === q) return true;

  const digits = q.replace(/\D/g, '');
  if (!digits) return false;
  if (country.dial.startsWith(digits) || digits.startsWith(country.dial)) return true;
  if (Array.isArray(country.areas) && country.areas.some((a) => a.startsWith(digits))) return true;
  return false;
}

export {
  PHONE_DEFAULT_ISO2,
  flagEmoji,
  phoneDigits,
  findPhoneCountry,
  countryFromE164Digits,
  parsePhone,
  isValidNational,
  isValidPhoneIntl,
  composePhone,
  formatPhoneForStorage,
  formatPhoneDisplay,
  phoneCountryMatches,
};
